import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import React from "react"
import PhoneContactLink from "./PhoneContactLink/PhoneContactLink"
import { useTranslation } from "react-i18next"

interface ContactInfo {
  name: string
  phoneNumber: string
}
interface Props {
  managerData: ContactInfo
  otherData: ContactInfo[]
}

const PhoneContactsComponent: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  return (
    <Box>
      {props.managerData ? (
        <>
          <Typography variant="h5" sx={{ marginBottom: 1 }}>
            {t("global.manager", "Manager")}
          </Typography>
          <PhoneContactLink name={props.managerData.name} phoneNumber={props.managerData.phoneNumber} />
        </>
      ) : null}

      {props?.otherData?.length > 0 ? (
        <>
          <Typography variant="h5" sx={{ marginTop: 2, marginBottom: 1 }}>
            {t("crisismanagement.contact_information_traffic_area", "Contact information Traffic area")}
          </Typography>
          {props.otherData.map(function (ContactInfo) {
            return <PhoneContactLink name={ContactInfo.name} phoneNumber={ContactInfo.phoneNumber} />
          })}
        </>
      ) : null}
    </Box>
  )
}

export default PhoneContactsComponent
